<template>
  <v-row>
    <v-col cols="6">
      <span class="caption">
        Published:
      </span>
      <span
        v-if="value.published_time.dateFormatted"
        class="caption font-weight-bold"
      >
        {{ value.published_time.dateFormatted }}
      </span>
      <span
        v-else
        class="caption font-italic"
      >
        No data
      </span>
    </v-col>
    <v-col cols="6">
      <span class="caption">
        Modified:
      </span>
      <span 
        v-if="value.modified_time.dateFormatted"
        class="caption font-weight-bold"
      >
        {{ value.modified_time.dateFormatted }}
      </span>
      <span
        v-else
        class="caption font-italic"
      >
        No data
      </span>
    </v-col>
  </v-row>
</template>

<script>
export default {
    props: {
        value: {
            type: Object,
            default: () => ({})
        },
    },
}
</script>
